import { parseNUmber } from './utils';

export const getProductDiscount = (product, productDiscounts) => {
    if ((product.discountType === 'percent' || product.discountType === 'amount') && product.discount) {
        return {};
    }
    let productDiscount = null;
    const discounts = [...productDiscounts].sort(
        (a, b) => new Date(b.createdAt).getDate() - new Date(a.createdAt).getDate(),
    );
    for (let i = 0; i < discounts.length && productDiscount === null; i++) {
        const discount = discounts[i];
        if (
            !discount?.products ||
            discount?.products.length === 0 ||
            discount?.products?.indexOf(product.variantGroupId || product.id) !== -1
        ) {
            productDiscount = discount;
        }
    }
    if (productDiscount) {
        return {
            discount: productDiscount.type === 'percent' ? productDiscount.percent : productDiscount.amount,
            discountType: productDiscount.type,
        };
    }
    return {};
};

export const hasDiscount = (product) => {
    return (product.discountType === 'percent' || product.discountType === 'amount') && product.discount;
};

export const applyDiscount = (product) => {
    if (!hasDiscount(product)) {
        return product.price;
    }
    if (product.discountType === 'percent') {
        const discount = product.price * (parseFloat(product.discount) / 100.0);
        return product.price - discount;
    }

    return product.price - parseNUmber(product.discount);
};
